module.exports = __webpack_public_path__ + "media/images/www/meta/company-af94fc3b8c0089ddfc4c41e976ab8f60.jpg";